import { TabInterface } from "src/app/shared/interfaces/tab-interface";
import { SubTypeEnum, WebMenuEnum } from "src/app/shared/enums/enums";
import { DesignType, StreamDesignType } from "src/app/profile/custom-tabs/tab-form/tab-form.component";

export class Addon {
  public Type: string;
  public BaseUrl: string;
  public OrganziationId?: any;
  public Domain?: string;
  public HomeTopicId?: string;
  public AccessToken?: string;
  public Id?: string
  public technadoptAuthData?: TechnadoptAuthData;
  public customTabData?: CustomTabData;
  public espClaimOwnershipData?: EspClaimOwnership;
  public PublicProperties?: PublicProperties;
  public Configuration?: Configuration;
  public InstanceId?: string;
  public EntityType?: string;
  public TeamIds?: Array<any>;
  public GroupIdenedi?: string;
}

export class TechnadoptAuthData {
  accessToken: string
  expiresIn: number
  roles: string[]
}

export interface EspClaimOwnership {
  url: string;
  name: string;
  id: number;
  filedId: string;
}

export class CustomTabData {
  name?: string
  productId?: string
  icon?: number
  viewOn?: string
  subtype?: SubTypeEnum
  customTabId?: string
}

export interface PublicProperties {
  access_token?: string
  baseURL?: string
  domain?: string
  groupIdenedi: string
  homeTopicId?: string
  icon?: number
  jsonData?: any
  name?: string
  organizationName?: string
  organziationId?: string
  hexColor?: string
  powerBiData?: any
  powerBiReportData?: any
  productId?: string
  productName?: string
  refresh_token?: string
  subtype?: number,
  dividers?:string,
  title?: string
  viewOn?: string,
  utilityType?: string,
  sortedTabs?: TabInterface[]
  tabOrder?: any[]
  customTabId?: string
  Active?: boolean
  language?: string
  logoUrl?: string
  lightNavBar?: string;
  footerFillColor?: string;
  /** "1" show footer logo, "0" hide (default visible when unset). */
  footerLogoVisible?: string;
  /** "1" show powered-by line, "0" hide (default visible when unset). Hidden when footerLogoVisible is "0". */
  footerPoweredByVisible?: string;
  fullScreenWidthOnDesktop?: string;
  fullScreenSizeOnDesktop?: string;
  fontSizeIncrease?: string;
  englishFont?: string;
  arabicFont?: string;
  backgroundColor?:string;
  isHighlightTab?: boolean
  footerDescription?: string,
  footerTitle?: string,
  groupMetaTitle?: string,
  groupMetaDescription?: string,
  groupMetaTitleArabic?: string,
  groupMetaDescriptionArabic?: string,
  subgroupsAccessList?: { [key: string]: string; }[];
  visibleBy?: { [key: string]: string }[];
  hiddenFrom?: { [key: string]: string }[];
  weblink?: string;
  directURLNavigationMenu?: WebMenuEnum;
  invitationText?: string;
  iFrameURL?: string;
  isLandingPageTab?: boolean;
  MeasurementId?: string;
  client_id?: string;
  RoomId?: string;
  loginRequired?: boolean;
  teamNames?: string;
  advancenavmenu?: string;
  sidenav?: string;
  footermenu?: string;
  footerLayout?: string;
  footer?: string;
  metaTitle?: string;
  metaDescription?: string;
  isDefaultTab?: number;
  secondaryIds?: string;
  refTab?: string;
  feedStream?: string;
  feedStreamDesign?: StreamDesignType;
  feedStreamLinkDesign?: DesignType;
  slug?: string;
  authUrl?: string;
  apiUrl?: string;
  api_url?: string;
  apiKey?: string;
  urlName?: string;
  tabLayout?: string;
  tabDescription?: string;
  bannerData?: {
    active?: string;
    heading?: string,
    subHeading?: string,
    backgroundImage?: string,
    action: {
      label?: string,
      link?: string
    },
    startDate?:string;
    endDate?:string;
  }
  customHeader?: string
  floatingTabPosition?: string;
  floatingTabView?: string;
  serviceName?: string;
  description?: string;
  isEnabled?: boolean;
  allowFeedOptions?: FeedOptions;
}

export interface Configuration {
  domain?: string,
  userId?: string,
  organziationId?: string,
  espTokenId?: number,
  baseURL?: string,
  access_token?: string,
  client_id?: string,
  client_secret?: string,
  grant_type?: string,
  refresh_token?: string
  publickey?: string,
  secretkey?: string
}

export class PowerBiData {
  displayName: string
  webUrl: string
  id: string
  isReadOnly: boolean
  groupId: string
  embedUrl: string
}


export class JsonData {
  constructor(public data: {
    iseditable: number
    isvisible: number
    key: string
    name: string
    order: number
  }[]) {
  }
}

export interface FeedOptions {
  likes: boolean;
  comments: boolean;
  announcer: boolean;
}